<template>
    <div class="verifyProtocol">
        <h3 class="title">隐私政策</h3>
        <div v-html="protocol"></div>
    </div>
</template>

<script>
import { protocol } from "./protocol";
export default {
    name: "verifyProtocol",

    data() {
        return {
            content: "",

            protocol: protocol.replace(/[\n]+/g, "<br/>"),
        };
    },
    mounted() {
        this.carItem = this.$route.params;
    },
    beforeRouteLeave(to, from, next) {
        // to.params = from.params;
        for (let k in this.carItem) {
            to.params[k] = this.carItem[k];
            to.query[k] = this.carItem[k];
        }
        next();
    },
};
</script>

<style lang="less" scoped>
.verifyProtocol {
    background-color: #fff;
    padding: 40px;

    .title {
        text-align: center;
    }
    .small-title {
        font-weight: bold;
    }

    .MsoNormal {
        text-indent: 2em;
    }
    .date {
        text-align: right;
    }
}
</style>
